import { createAction, props } from '@ngrx/store';

export enum UtilsActionTypes {
    MostrarSpinner = '[Util] Mostrar Spinner',
    OcultarSpinner = '[Util] Ocultar Spinner',
    MostrarExcepcion = '[Util] Mostrar Excepcion',
    OcultarExcepcion = '[Util] Ocultar Excepcion',
    MostrarMenu = '[Util] Mostrar Menu',
    SeleccionarEmpresa = '[Util] Seleccionar Empresa',
}

export const MostrarSpinner = createAction(UtilsActionTypes.MostrarSpinner);
export const OcultarSpinner = createAction(UtilsActionTypes.OcultarSpinner);
export const MostrarExcepcion = createAction(UtilsActionTypes.MostrarExcepcion, props<{ pila: any, tipoExcepcion: number }>());
export const OcultarExcepcion = createAction(UtilsActionTypes.OcultarExcepcion);
export const MostrarMenu = createAction(UtilsActionTypes.MostrarMenu, props<{ mostrarMenu: boolean }>());
export const SeleccionarEmpresa = createAction(UtilsActionTypes.SeleccionarEmpresa, props<{ empresaSeleccionada: any }>());

